module.exports = __webpack_public_path__ + "img/sg.127097a7.svg";